import React from 'react';
import PropTypes from 'prop-types';

export const Section = ({
  className,
  children,
  backgroundColor,
  decorations,
  positionLeft,
  positionRight
}) => {
  return (
    <div className={`Section ${className || ''} ${decorations ? 'Section--decorations' : ''}`} style={backgroundColor && { backgroundColor }}>
      {
        (decorations && decorations.left) &&
          <div className={`Section__decoration Section__decoration--left ${positionLeft ? 'position--'+positionLeft : ''}`}>
            <img src={decorations.left} alt="" />
          </div>
      }
      <div className="Section__body">
        {children}
      </div>
      {
        (decorations && decorations.right) &&
        <div className={`Section__decoration Section__decoration--right ${positionRight ? 'position--'+positionRight : ''}`}>
            <img src={decorations.right} alt="" />
          </div>
      }
    </div>
  )
};

Section.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  decorations: PropTypes.object,
  positionLeft: PropTypes.oneOf(['top', 'center','bottom']),
  positionRight: PropTypes.oneOf(['top', 'center','bottom']),
};

Section.defaultProps = {
  className: undefined,
  decorations: undefined,
  positionLeft: 'center',
  positionRight: 'center'
};
